import React, { useState } from 'react';
import styles from './PriceCalculationPage.module.scss';
import { X } from 'lucide-react';
import ChemicalPricesTab from '../components/PriceCalculation/ChemicalPricesTab';
import ProductPricesTab from '../components/PriceCalculation/ProductPricesTab';
import CalculatorTab from '../components/PriceCalculation/CalculatorTab';
import ProductPriceHistory from '../components/PriceCalculation/ProductPriceHistory';

const TABS = {
  chemical: 'chemical',
  product: 'product',
  calculator: 'calculator',
  history: 'history',
};

export default function PriceCalculationPage() {
  const [activeTab, setActiveTab] = useState(TABS.chemical);
  const [error, setError] = useState(null);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Price Calculation</h2>
        <p>Manage chemical and product prices per kg, and run calculations.</p>
      </div>

      <div className={styles.tabs}>
        <button
          type="button"
          className={`${styles.tab} ${activeTab === TABS.chemical ? styles.active : ''}`}
          onClick={() => setActiveTab(TABS.chemical)}
        >
          Chemical prices
        </button>
        <button
          type="button"
          className={`${styles.tab} ${activeTab === TABS.product ? styles.active : ''}`}
          onClick={() => setActiveTab(TABS.product)}
        >
          Product prices
        </button>
        <button
          type="button"
          className={`${styles.tab} ${activeTab === TABS.calculator ? styles.active : ''}`}
          onClick={() => setActiveTab(TABS.calculator)}
        >
          Calculator
        </button>
        <button
          type="button"
          className={`${styles.tab} ${activeTab === TABS.history ? styles.active : ''}`}
          onClick={() => setActiveTab(TABS.history)}
        >
          Price history
        </button>
      </div>

      {error && (
        <div className={styles.error}>
          <span>{error}</span>
          <button type="button" onClick={() => setError(null)}>
            <X size={18} />
          </button>
        </div>
      )}

      <div className={styles.tabPanel}>
        {activeTab === TABS.chemical && (
          <ChemicalPricesTab onError={setError} />
        )}
        {activeTab === TABS.product && (
          <ProductPricesTab onError={setError} />
        )}
        {activeTab === TABS.calculator && (
          <CalculatorTab onError={setError} />
        )}
        {activeTab === TABS.history && (
          <ProductPriceHistory onError={setError} />
        )}
      </div>
    </div>
  );
}
